module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-app-polyfill/node_modules/core-js/internals/iterators.js
// module id = 252
// module chunks = 1